/*
 * @Description: 角色管理
 * @Author: fxg
 * @Date: 2020-06-29 11:18:28
 * @LastEditors: fxg
 * @LastEditTime: 2020-06-29 13:34:36
*/
import request from '@/utils/request'
export const Download = "/base/system/role/export";
export function batchUpdateOrDelete(data) {
  return request({
    url: '/base/system/role/batch_update_or_delete',
    method: 'post',
    data
  })
}
export function getDetail() {
  return request({
    url: '/base/system/role/get_detail',
    method: 'get'
  })
}
export function queryPage(data) {
  return request({
    url: '/base/system/role/query_page',
    method: 'post',
    data
  })
}

export function queryRolePageByLimit(data) {
  return request({
    url: '/base/system/role/query_page',
    method: 'post',
    data
  })
}

export function saveOrUpdate(data) {
  return request({
    url: '/base/system/role/save_or_update',
    method: 'post',
    data
  })
}
export function updateSortNum(data) {
  return request({
    url: '/base/system/role/update_sort_num',
    method: 'post',
    data
  })
}
/*获取角色与用户绑定关系*/
export function getopList(params) {
  return request({
    url: '/base/system/role/user/get_list',
    method: 'get',
    params
  })
}
/*保存角色与用户绑定关系*/
export function rusaveOrUpdate(data) {
  return request({
    url: '/base/system/role/user/save_or_update',
    method: 'post',
    data
  })
}
/*获取用户id或者角色id列表*/
export function userget_Ids(params) {
  return request({
    url: '/base/system/role/user/get_Ids',
    method: 'get',
    params
  })
}